import { FormControlLabel, Grid } from '@material-ui/core';
import React from 'react';
import { SecondaryCheckbox } from '../../../Core/FormInput';

const WorkflowNotification = (props) => {
    const { workflowsNotificationList, onClose } = props;

    const handleCheckboxChange = (e, fielId) => {
        console.log('e', e, 'fielId', fielId);
        props.handleCheckbox(e, fielId);
    };

    return (
        <div style={{ height: '400px', width: '100%', overflow: 'auto' }}>
            <Grid container>
                {workflowsNotificationList.map(({ name, active, id }, index) => {
                    return (
                        <Grid item xs={6} md={3} key={index}>
                            <FormControlLabel
                                control={<SecondaryCheckbox checked={active} onChange={(e) => handleCheckboxChange(e, id)} name={name} />}
                                label={name}
                            />
                        </Grid>
                    );
                })}
            </Grid>
        </div>
    );
};

export default WorkflowNotification;
